import React from 'react';
import { KeyRound, Lock } from 'lucide-react';
const codeSlots = Array.from({
  length: 10
}, (_, i) => i + 1);
export function BackupCodesMockup() {
  return <div className="w-[32cqw] -rotate-2 border-2 border-mm-charcoal bg-mm-white px-[2.4cqw] py-[2cqw] font-body shadow-[0.8cqw_0.8cqw_0_0_rgba(34,34,34,0.12)]" data-id="element-35" data-mp="1syh6cd3zqybt">
      <div className="flex items-center gap-[0.8cqw]" data-id="element-36" data-mp="1izi9drsl8r4n">
        <KeyRound className="h-[1.8cqw] w-[1.8cqw] text-mm-orange" aria-hidden="true" data-id="element-37" data-mp="2glz20jqdmgk2" />
        <p className="font-heading text-[1.6cqw] font-bold text-mm-black" data-id="element-38" data-mp="2gntinlum7mic">Stripe backup codes</p>
      </div>
      <p className="mt-[0.4cqw] text-[1.05cqw] text-mm-mid-gray" data-id="element-39" data-mp="26w5t5qhmcfji">Leslie Outreach · written by hand</p>
      <ul className="mt-[1.4cqw] grid grid-cols-2 gap-x-[2cqw] gap-y-[1cqw]" data-id="element-40" data-mp="21xcf9wyf6mit">
        {codeSlots.map(slot => <li key={slot} className="border-b border-dashed border-mm-light-gray pb-[0.3cqw] font-mono text-[1.3cqw] tracking-[0.12em] text-mm-muted-charcoal" data-id="element-41" data-mp="2zd043gmsms7u">
            {slot}. ••••-••••
          </li>)}
      </ul>
      <p className="mt-[1.6cqw] flex items-center gap-[0.6cqw] text-[1.05cqw] text-mm-mid-gray" data-id="element-42" data-mp="3i2eqylp2pqzv">
        <Lock className="h-[1.2cqw] w-[1.2cqw]" aria-hidden="true" data-id="element-43" data-mp="3n1hkp9zlsasj" />
        Somewhere safe. Not on the computer.
      </p>
    </div>;
}